import {
  useAdminCreateClubMutation,
} from '@features/club/api/hooks';
import { ClubCreateForm } from '@features/club/ui/ClubCreateForm/ClubCreateForm';
import { useCallback } from 'react';
import { ClubCreateFormValues } from '@features/club/ui/ClubCreateForm/index';

export type Props = {
  onCancel: () => void;
  onSubmitSuccess: (values: ClubCreateFormValues) => void;
};

export function ClubCreateFormWidget({ onCancel, onSubmitSuccess }: Props) {
  const { mutateAsync: onSubmit } = useAdminCreateClubMutation();

  const onSubmitHandler = useCallback(async (values: ClubCreateFormValues) => {
    try {
      await onSubmit(values);
    } finally {
      onSubmitSuccess(values);
    }
    return values;
  }, [onSubmit, onSubmitSuccess]);

  return (
    <ClubCreateForm onSubmit={onSubmitHandler} onCancel={onCancel} />
  );
}
